export default {
  /**
   * Parse window.location.href and extract all query string params
   */
  getHrefParameters() {
    let params = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
      params[key] = value;
    });
    return params;
  },

  /**
   * Get the query string of the current funnel
   * @returns {String} Either f=?, funnel=?, or ''
   */
  getCurrentFunnelQueryString() {
    let params = this.getHrefParameters();
    if (params['f']) {
      return `f=${params['f']}`;
    }
    if (params['funnel']) {
      return `funnel=${params['funnel']}`;
    }
    return '';
  },

  /**
   * Relative path for checkout page in case a failed/errored out payment recovery is needed by the user
   */
  getCheckoutRecoveryPath(offer) {
    return `/checkout/${offer}?rb=user&${this.getCurrentFunnelQueryString()}`;
  },

  /**
   * Determine whether the current user is eligible for taxation on orders
   * @returns boolean
   */
  getCustomerEligibleForTax() {
    const eligible = document.head.querySelector('meta[name="tax-eligible"]');

    if (eligible) {
      return !!eligible.content;
    }

    return false;
  },

  unauthenticatedLogout() {
	  localStorage.setItem('logout_message', 'Your session has expired. Please log in again');
	  window.location.reload();
  },

  async generateHash(dataToHash) {
	  // Create a hash using Web Crypto API (browser-compatible)
	  const encoder = new TextEncoder();
	  const dataBuffer = encoder.encode(JSON.stringify(dataToHash));
	  const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer);
	  const hashArray = Array.from(new Uint8Array(hashBuffer));
	  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  }
};
